﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { applyThemeStyles } from "~base/Styling";
import { createUseStyles } from "react-jss";
import { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";
import {
    NotFoundPageCustomizations,
    NotFoundPageDefaultCustomization,
} from "./Customization";
import { JssClass } from "~base/Styling";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export interface ReactComponentClasses {
    header: string;
    bottom: string;
    splashButton: string;
}

export interface ReactComponentStyles {
    header: JssClass;
    bottom: JssClass;
    splashButton: JssClass;
}

export const useAdditionalStyles = (
    customization?: NotFoundPageCustomizations
): (() => ReactComponentClasses) =>
    createUseStyles((theme: ConsilioBaseTheme): ReactComponentStyles => {
        const styles = {
            header: applyThemeStyles(
                NotFoundPageDefaultCustomization.customStyles?.header,
                {},
                customization.customStyles?.header
            ),
            bottom: applyThemeStyles(
                NotFoundPageDefaultCustomization.customStyles?.bottom,
                {},
                customization.customStyles?.bottom
            ),
            splashButton: applyThemeStyles(
                theme.components.pages.shared.splashPage.splashScreen,
                {}
            ),
        };

        return styles;
    }) as () => ReactComponentClasses;
